<template>
  <div class="asc-add-new-repeater-issue-dialog">
    <asc-dialog
      text="OPEN A NEW ISSUE"
      :show-dialog="showDialog"
      :on-close="handleClose"
      :width="443"
      :primary-available="isFormValid"
      :on-primary="handleAddNewRepeatersSubmit"
      primary-button-text="OPEN ISSUE"
    >
      <template v-if="showDialog">
        <asc-spinner-wrapper :loading="loading">
          <v-container class="pa-0 mt-2 mb-10">
            <v-row no-gutters>
              <v-col cols="12" class="mb-7">
                <asc-autocomplete-selector
                  id="tail"
                  v-model="selectedTailId"
                  :items="tails"
                  placeholder="Select a Tail"
                  label="Tail"
                  required
                  no-array
                  fixed-position
                ></asc-autocomplete-selector>
              </v-col>
              <v-col cols="12" class="mb-7">
                <asc-autocomplete-selector
                  id="ataChapters"
                  v-model="selectedAtaChapters"
                  :items="ataChapters"
                  placeholder="Select a ATA Chapters"
                  label="ATA Chapters"
                  required
                  no-array
                  fixed-position
                  component-type="multiple"
                ></asc-autocomplete-selector>
              </v-col>
            </v-row>
          </v-container>
        </asc-spinner-wrapper>
      </template>
    </asc-dialog>
  </div>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'

export default {
  name: 'AscAddRepeaterIssueDialog',

  components: {
    AscDialog,
    AscSpinnerWrapper,
    AscAutocompleteSelector,
  },

  mixins: [AscDialogMixin],

  props: {
    tails: {
      type: Array,
      default: () => [],
    },
    ataChapters: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      selectedTailId: null,
      selectedAtaChapters: [],
    }
  },
  computed: {
    isFormValid() {
      return this.selectedTailId !== null && this.selectedAtaChapters.length > 0
    },
  },
  methods: {
    handleAddNewRepeatersSubmit() {
      const data = {
        tail: this.tails.find(tail => tail.value === this.selectedTailId),
        ataChapters: this.selectedAtaChapters,
      }

      this.$emit('onOpenIssue', data)

      this.resetform()
    },
    resetform() {
      this.selectedTailId = null
      this.selectedAtaChapters = []
    },
    handleClose() {
      if (this.onClose && !this.loading) {
        this.resetform()
        this.onClose()
      }
    },
  },
}
</script>
<style lang="scss">
.asc-add-new-repeater-issue-dialog {
  .asc-dialog {
    .v-card {
      .asc-dialog-slot {
        overflow-x: hidden;
      }

      &__actions {
        .row {
          > div {
            width: 100%;

            .v-btn {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
